<template>
  <div class="w-full flex justify-end">
    <button v-if="!isRetinoscopy && settingsStore.getValue('show_qr_codes_on_eye_examination_reports') == 'true'"
            class="text-black mb-1 mx-2 hover:text-blue-600 font-bold"
            @click="downloadQR">
      <Icon icon="mdi:qrcode" width="18" height="18" />
    </button>
    <button v-if="!isRetinoscopy && settingsStore.getValue('hide_examination_id_print') == 'false'" class="text-black mx-2 hover:text-blue-600 font-bold" @click="btnClickedHandler('id_card')">
      <span class="fa fa-credit-card"></span>
    </button>
    <button
      class="text-black mx-2 hover:text-blue-600 font-bold"
      @click="btnClickedHandler('print')"
    >
      <span class="fa fa-print"></span>
    </button>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { Icon } from '@iconify/vue'
import {useSettingsStore} from "@/stores/settingsStore";
import {exportQRCode} from '@/utils/qrExport'
import samiLogo from '@/assets/images/logo.svg'
import {EXAM_TYPE_RETINOSCOPY} from '@/models/customer/Examination'
import {formatPostgresDate} from '@/utils/date'

export default defineComponent({
  components: { Icon },
  data(vm) {
    return {
      settingsStore: useSettingsStore()
    }
  },
  computed: {
    isRetinoscopy(): boolean {
      /* @ts-ignore */
      return this.params.data?.examType === EXAM_TYPE_RETINOSCOPY
    }
  },
  methods: {
    btnClickedHandler(action: string) {
      /* @ts-ignore */
      this.params.onPrintBtnClicked(action, this.params.data)
    },
    async downloadQR() {
      const examination = this.params.data
      const logoSrc = this.settingsStore.getValue('examination_main_logo')
        ? this.settingsStore.storagePath + '/' + this.settingsStore.getValue('examination_main_logo')
        : samiLogo
      const qrUrl = `https://exams.thecky.com/${this.settingsStore.getValue('viewer_client_key') || 'test'}/${examination.id}`
      await exportQRCode({
        qrUrl,
        logoSrc,
        customerName: examination.customer?.name,
        externalID: examination.externalID,
        examDate: examination.createdAt ? formatPostgresDate(String(examination.createdAt), 'DD-MM-YYYY') : '',
        brandColor: this.settingsStore.getValue('receipt_branding_color'),
        style: this.settingsStore.getValue('examination_qr_image_style')
      })
    }
  }
})
</script>
